import { JsonApiModel, JsonApiModelConfig, Attribute, BelongsTo } from 'angular2-jsonapi'

import { UserConnection } from './user-connection.model'

@JsonApiModelConfig({
    type: 'bureaus'
})
export class Bureau extends JsonApiModel {
    @Attribute() integracaoWCont: IntegracaoWCont

    @BelongsTo() userConnection: UserConnection
}

export interface IntegracaoWCont {
    codigosDeChamada: any[]
    codigosContabeis: {
        nomeDaOperadora: string
        bandeira: string
        vendaCredito: string
        vendaDebito: string
        recebimentoLiquidoCredito: string
        recebimentoLiquidoDebito: string
        taxaOperadoraCredito: string
        taxaOperadoraDebito: string
        estornoDeVendasCredito: string
        estornoDeVendasDebito: string
        antecipacaoTaxa: string
        aluguel: string
        outrosAjustes: string
    }[]
}



// WEBPACK FOOTER //
// ./src/app/pkw-data/core/bureau.model.ts